import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons";
import { Z_AI_CONFIRM_OVERLAY } from "./workoutAdminHelpers";

export default function AIConfirmModal({
  aiForm,
  selectedStudent,
  handleGenerate,
  setAiConfirmOpen,
}) {
  return createPortal(
        <div
          style={{
            position: "fixed", inset: 0, zIndex: Z_AI_CONFIRM_OVERLAY,
            background: "rgba(8,15,32,0.75)", backdropFilter: "blur(10px)",
            display: "flex", alignItems: "flex-start", justifyContent: "center", overflowY: "auto",
            paddingTop: "max(env(safe-area-inset-top, 20px), 20px)", paddingLeft: 20, paddingRight: 20, paddingBottom: 20,
          }}
          onClick={() => setAiConfirmOpen(false)}
        >
          <div
            style={{
              width: "min(500px,94vw)", background: "var(--surface-primary)",
              border: "1px solid var(--border-0-10)", borderRadius: 20,
              boxShadow: "0 24px 70px rgba(0,0,0,0.7)", padding: "24px 24px 20px",
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Header */}
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
              <div style={{
                width: 36, height: 36, borderRadius: 10,
                background: "var(--accent-0-15)", border: "1px solid rgba(var(--accent-rgb),0.3)",
                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
              }}>
                <FontAwesomeIcon icon={faWandMagicSparkles} style={{ color: "var(--feedback-success)", fontSize: 16 }} />
              </div>
              <div>
                <h3 style={{ margin: 0, color: "var(--text-primary)", fontSize: 15, fontWeight: 700 }}>
                  Confirmar geração
                </h3>
                <p style={{ margin: 0, color: "var(--text-0-50)", fontSize: 12 }}>
                  Revise antes de enviar à IA
                </p>
              </div>
            </div>

            {/* Resumo dos parâmetros */}
            <div style={{
              background: "rgba(255,255,255,0.04)", border: "1px solid var(--border-0-08)",
              borderRadius: 12, padding: "14px 16px", marginBottom: 14,
              display: "flex", flexDirection: "column", gap: 8,
            }}>
              {[
                ["Aluno",        selectedStudent?.name || "-"],
                ["Objetivo",     { hipertrofia: "Hipertrofia", força: "Força", emagrecimento: "Emagrecimento", condicionamento: "Condicionamento", reabilitação: "Reabilitação" }[aiForm.goals[0]] || aiForm.goals[0]],
                ["Dias/semana",  `${aiForm.days_per_week}x`],
                ["Duração",      `${aiForm.session_duration_minutes} min/sessão`],
                ["Foco",         { "": "Equilibrado", superiores: "Superiores", inferiores: "Inferiores", glúteos: "Glúteos", core: "Core", lombar: "Lombar", obliquos: "Oblíquos" }[aiForm.focus] || aiForm.focus],
                ...(aiForm.restrictions ? [["Restrições", aiForm.restrictions]] : []),
                ...(aiForm.secondary_goals.length ? [["Objetivos adicionais", aiForm.secondary_goals.join(", ")]] : []),
                ...(aiForm.include_cardio ? [["Cardio", `${aiForm.cardio_type} · ${aiForm.cardio_duration_minutes} min`]] : []),
              ].map(([label, value]) => (
                <div key={label} style={{ display: "flex", gap: 8, fontSize: 13 }}>
                  <span style={{ color: "var(--text-0-50)", minWidth: 130, flexShrink: 0 }}>{label}</span>
                  <span style={{ color: "var(--text-primary)", fontWeight: 500 }}>{value}</span>
                </div>
              ))}
            </div>

            {/* Notas técnicas (se houver) */}
            {aiForm.teacher_notes && (
              <div style={{
                background: "rgba(var(--accent-rgb),0.08)", border: "1px solid rgba(var(--accent-rgb),0.22)",
                borderRadius: 10, padding: "10px 12px", marginBottom: 14,
                fontSize: 12, color: "rgba(159,225,203,0.85)", lineHeight: 1.5,
              }}>
                <span style={{ color: "var(--feedback-success)", fontWeight: 600, display: "block", marginBottom: 4, fontSize: "var(--fs-xs)", letterSpacing: .4 }}>
                  INSTRUÇÕES DO PROFESSOR
                </span>
                {aiForm.teacher_notes.length > 180
                  ? aiForm.teacher_notes.slice(0, 180) + "…"
                  : aiForm.teacher_notes}
              </div>
            )}

            {/* Custo estimado */}
            <div style={{
              display: "flex", alignItems: "center", gap: 8,
              padding: "9px 12px", borderRadius: 10,
              background: "rgba(239,159,39,0.07)", border: "1px solid rgba(239,159,39,0.18)",
              marginBottom: 20,
            }}>
              <FontAwesomeIcon icon={faCircleInfo} style={{ color: "var(--feedback-warning)", fontSize: 13, flexShrink: 0 }} />
              <p style={{ margin: 0, fontSize: 12, color: "rgba(245,210,130,0.85)", lineHeight: 1.4 }}>
                Cada geração consome créditos de IA. Revise os parâmetros antes de confirmar.
              </p>
            </div>

            {/* Ações */}
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button
                style={{
                  background: "var(--border-0-06)", color: "var(--text-primary)",
                  border: "1px solid var(--border-0-10)", borderRadius: 10,
                  padding: "9px 18px", fontWeight: 600, fontSize: 14, cursor: "pointer",
                }}
                onClick={() => setAiConfirmOpen(false)}
              >
                Revisar
              </button>
              <button
                style={{
                  background: "var(--accent)", color: "var(--on-accent)", border: "none", borderRadius: 10,
                  padding: "9px 22px", fontWeight: 700, fontSize: 14, cursor: "pointer",
                  display: "flex", alignItems: "center", gap: 8,
                }}
                onClick={handleGenerate}
              >
                <FontAwesomeIcon icon={faWandMagicSparkles} />
                Confirmar e gerar
              </button>
            </div>
          </div>
        </div>,
        document.body
      )
}
